/* Copyright Levelise Ltd 2024 - 2026 */
import { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.handleReload = this.handleReload.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught an error:', error, info.componentStack);
    }

    handleReload() {
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            return (
                <div id="loading-route">
                    <p>Something went wrong loading this page.</p>
                    <button onClick={this.handleReload}>Reload</button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
